tinymce.addI18n("cy", {
    "#": "#",
    "Accessibility": "Hygyrchedd",
    "Accordion": "Acordion",
    "Accordion body...": "Corff acordion...",
    "Accordion summary...": "Crynodeb acordion...",
    "Action": "Gweithred",
    "Activity": "Gweithgaredd",
    "Address": "Cyfeiriad",
    "Advanced": "Uwch",
    "Align": "Alinio",
    "Align center": "Aliniad canol",
    "Align left": "Aliniad chwith",
    "Align right": "Aliniad de",
    "Alignment": "Aliniad",
    "Alignment {0}": "Aliniad {0}",
    "All": "Y cwbl",
    "Alternative description": "Disgrifiad arall",
    "Alternative source": "Ffynhonnell arall",
    "Alternative source URL": "Ffynhonnell URL arall",
    "Anchor": "Angor",
    "Anchor...": "Angor...",
    "Anchors": "Angorau",
    "Animals and Nature": "Anifeiliaid a Natur",
    "Arrows": "Saethau",
    "B": "Gl",
    "Background color": "Lliw cefndir",
    "Background color {0}": "Lliw cefndir {0}",
    "Black": "Du",
    "Block": "Bloc",
    "Block {0}": "Bloc {0}",
    "Blockquote": "Dyfyniad Bloc",
    "Blocks": "Blociau",
    "Blue": "Glas",
    "Blue component": "Cydran las",
    "Body": "Corff",
    "Bold": "Trwm",
    "Border": "Border",
    "Border color": "Lliw Border",
    "Border style": "Steil border",
    "Border width": "Lled border",
    "Bottom": "Gwaelod",
    "Browse files": "Pori ffeiliau",
    "Browse for an image": "Pori am ddelwedd",
    "Browse links": "Pori dolenni",
    "Bullet list": "Rhestr fwled",
    "Cancel": "Canslo",
    "Caption": "Capsiwn",
    "Cell": "Cell",
    "Cell padding": "Padio celloedd",
    "Cell properties": "Priodweddau'r gell",
    "Cell spacing": "Bylchiad celloedd",
    "Cell styles": "Arddulliau cell",
    "Cell type": "Math y gell",
    "Center": "Canol",
    "Characters": "Nodau",
    "Characters (no spaces)": "Nodau (dim gofod)",
    "Circle": "Cylch",
    "Class": "Dosbarth",
    "Clear formatting": "Clirio pob fformat",
    "Close": "Cau",
    "Code": "Cod",
    "Code sample...": "Sampl cod...",
    "Code view": "Golwg cod",
    "Color Picker": "Dewisydd Lliw",
    "Color swatch": "Casgliad lliwiau",
    "Cols": "Colofnau",
    "Column": "Colofn",
    "Column clipboard actions": "Camau clipfwrdd colofn",
    "Column group": "Gr\u0175p colofn",
    "Column header": "Pennyn colofn",
    "Constrain proportions": "Cyfyngu cyfranneddau",
    "Copy": "Cop\xefo",
    "Copy column": "Cop\xefo colofn",
    "Copy row": "Cop\xefo rhes",
    "Could not find the specified string.": "Methu dod o hyd 'r llinyn dan sylw.",
    "Could not load emojis": "Ddim yn gallu llwytho emojis",
    "Count": "Cyfrif",
    "Currency": "Arian cyfred",
    "Current window": "Ffenestr gyfredol",
    "Custom color": "Lliw personol",
    "Custom...": "Personol...",
    "Cut": "Torri",
    "Cut column": "Torri colofn",
    "Cut row": "Torri rhes",
    "Dark Blue": "Glas Tywyll",
    "Dark Gray": "Llwyd tywyll",
    "Dark Green": "Gwyrdd tywyll",
    "Dark Orange": "Oren tywyll",
    "Dark Purple": "Porffor Tywyll",
    "Dark Red": "Coch tywyll",
    "Dark Turquoise": "Gwyrddlas tywyll",
    "Dark Yellow": "Melyn tywyll",
    "Dashed": "Llinell doredig",
    "Date/time": "Dyddiad/amser",
    "Decrease indent": "Lleihau mewnoliad",
    "Default": "Diofyn",
    "Delete accordion": "Dileu acordion",
    "Delete column": "Dileu colofn",
    "Delete row": "Dileu rhes",
    "Delete table": "Dileu'r tabl",
    "Dimensions": "Dimensiynau",
    "Disc": "Disg",
    "Div": "Div",
    "Document": "Dogfen",
    "Dotted": "Dotiog",
    "Double": "Dwbl",
    "Drop an image here": "Gollwng delwedd yma",
    "Dropped file type is not supported": "Dyw\u2019r math o ffeil a ollyngwyd ddim yn cael ei gefnogi",
    "Edit": "Golygu",
    "Embed": "Mewnblannu",
    "Emojis": "Emojis",
    "Emojis...": "Emojis\u2026",
    "Error": "Gwall",
    "Error: Form submit field collision.": "Gwall: Gwrthdrawiad maes cyflwyno ffurflen",
    "Error: No form element found.": "Gwall: Ni chafwyd elfen ffurflen",
    "Extended Latin": "Lladin estynedig",
    "Failed to initialize plugin: {0}": "Wedi methu ymgychwyn yr ategyn: {0}",
    "Failed to load plugin url: {0}": "Wedi methu llwytho url yr ategyn: {0}",
    "Failed to load plugin: {0} from url {1}": "Wedi methu llwytho'r ategyn: {0} o'r url {1}",
    "Failed to upload image: {0}": "Wedi methu uwchlwytho'r ddelwedd: {0}",
    "File": "Ffeil",
    "Find": "Chwilio",
    "Find (if searchreplace plugin activated)": "Canfod (os yw'r ategyn chwilio ac amnewid yn weithredol)",
    "Find and Replace": "Canfod a Newid",
    "Find and replace...": "Chwilio ac amnewid",
    "Find in selection": "Canfod yn y dewisiad",
    "Find whole words only": "Canfod geiriau llawn yn unig",
    "Flags": "Baneri",
    "Focus to contextual toolbar": "Ffocws i far offer y cyd-destun",
    "Focus to element path": "Ffocws i lwybr elfen",
    "Focus to menubar": "Ffocws i'r bar dewislen",
    "Focus to toolbar": "Ffocws i'r bar offer",
    "Font": "Ffont",
    "Font size {0}": "Maint ffont {0}",
    "Font sizes": "Meintiau ffont",
    "Font {0}": "Ffont {0}",
    "Fonts": "Ffontau",
    "Food and Drink": "Bwyd a Diod",
    "Footer": "Troedyn",
    "Format": "Fformat",
    "Format {0}": "Fformat {0}",
    "Formats": "Fformatau",
    "Fullscreen": "Sgrin llawn",
    "G": "Gw",
    "General": "Cyffredinol",
    "Gray": "d",
    "Green": "Gwyrdd",
    "Green component": "Cydran werdd",
    "Groove": "Rhych",
    "Handy Shortcuts": "Llwybrau byr cyfleus",
    "Header": "Pennyn",
    "Header cell": "Cell bennyn",
    "Heading 1": "Pennawd 1",
    "Heading 2": "Pennawd 2",
    "Heading 3": "Pennawd 3",
    "Heading 4": "Pennawd 4",
    "Heading 5": "Pennawd 5",
    "Heading 6": "Pennawd 6",
    "Headings": "Penawdau",
    "Height": "Uchder",
    "Help": "Cymorth",
    "Hex color code": "Cod lliw hecs",
    "Hidden": "Cudd",
    "Horizontal align": "Alinio llorweddol",
    "Horizontal line": "Llinell lorweddol",
    "Horizontal space": "Gofod llorweddol",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "Dylai\u2019r ID gychwyn gyda llythyren, yn cael ei ddilyn gan ddim ond lythrennau, rhifau, llinellau toredig, dotiau, colonau neu thanlinellau.",
    "Image is decorative": "Delwedd yn addurniadol",
    "Image list": "Rhestr delweddau",
    "Image title": "Teitl delwedd",
    "Image...": "Delwedd...",
    "ImageProxy HTTP error: Could not find Image Proxy": "Gwall HTTP ImageProxy: methwyd dod o hyd i Image Proxy",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "Gwall HTTP ImageProxy: URL Image Proxy anghywir",
    "ImageProxy HTTP error: Rejected request": "Gwall HTTP ImageProxy: cais wedi\u2019i wrthod",
    "ImageProxy HTTP error: Unknown ImageProxy error": "Gwall HTTP ImageProxy: gwall ImageProxy anhysbys",
    "Increase indent": "Cynyddu mewnoliad",
    "Inline": "Mewnlin",
    "Insert": "Mewnosod",
    "Insert Template": "Mewnosod templed",
    "Insert accordion": "Mewnosod acordion",
    "Insert column after": "Mewnosod colofn ar \xf4l",
    "Insert column before": "Mewnosod colofn cyn",
    "Insert date/time": "Mewnosod dyddiad/amser",
    "Insert image": "Mewnosod delwedd",
    "Insert link (if link plugin activated)": "Mewnosod dolen (os yw'r ategyn dolen yn weithredol)",
    "Insert row after": "Mewnosod rhes ar \xf4l",
    "Insert row before": "Mewnosod rhes cyn",
    "Insert table": "Mewnosod tabl",
    "Insert template...": "Mewnosod templed...",
    "Insert video": "Mewnosod fideo",
    "Insert/Edit code sample": "Mewnosod/golygu sampl cod",
    "Insert/edit image": "Mewnosod/golygu delwedd",
    "Insert/edit link": "Mewnosod/golygu dolen",
    "Insert/edit media": "Mewnosod/golygu cyfrwng",
    "Insert/edit video": "Mewnosod/golygu fideo",
    "Inset": "Encilio",
    "Invalid hex color code: {0}": "Cod lliw hecs annilys: {0}",
    "Invalid input": "Mewnbwn annilys",
    "Italic": "Italig",
    "Justify": "Unioni",
    "Keyboard Navigation": "Llywio Bysellfwrdd",
    "Language": "Iaith",
    "Learn more...": "Dysgu Mwy...",
    "Left": "Chwith",
    "Left to right": "Chwith i'r dde",
    "Light Blue": "Glas Golau",
    "Light Gray": "Llwyd golau",
    "Light Green": "Gwyrdd Golau",
    "Light Purple": "Porffor Golau",
    "Light Red": "Coch Golau",
    "Light Yellow": "Melyn Golau",
    "Line height": "Uchder llinell",
    "Link list": "Rhestr dolenni",
    "Link...": "Dolen...",
    "List Properties": "Rhestru Priodweddau",
    "List properties...": "Rhestru priodweddau...",
    "Loading emojis...": "Llwytho emojis\u2026",
    "Loading...": "Llwytho\u2026",
    "Lower Alpha": "Llythrennau Bach",
    "Lower Greek": "Groeg (Llythrennau Bach)",
    "Lower Roman": "Rhufeinig (Llythrennau Bach)",
    "Match case": "Cydweddu cas",
    "Mathematical": "Mathemategol",
    "Media poster (Image URL)": "Poster cyfrwng (URL delwedd)",
    "Media...": "Cyfrwng...",
    "Medium Blue": "Glas canolig",
    "Medium Gray": "Llwyd canolig",
    "Medium Purple": "Porffor canolig",
    "Merge cells": "Cyfuno celloedd",
    "Middle": "Canol",
    "Midnight Blue": "Glas y nos",
    "More...": "Mwy...",
    "Name": "Enw",
    "Navy Blue": "Dulas",
    "New document": "Dogfen newydd",
    "New window": "Ffenestr newydd",
    "Next": "Nesaf",
    "No": "Na",
    "No alignment": "Dim aliniad",
    "No color": "Dim Lliw",
    "Nonbreaking space": "Bwlch di-dor",
    "None": "Dim",
    "Numbered list": "Rhestr rifol",
    "OR": "NEU",
    "Objects": "Gwrthrychau",
    "Ok": "Iawn",
    "Open help dialog": "Agor y ddeialog gymorth",
    "Open link": "Agor dolen",
    "Open link in...": "Agor dolen yn...",
    "Open popup menu for split buttons": "Agor naidlen ar gyfer botymau hollt",
    "Orange": "Oren",
    "Outset": "Ymwthio",
    "Page break": "Toriad tudalen",
    "Paragraph": "Paragraff",
    "Paste": "Gludo",
    "Paste as text": "Gludo fel testun",
    "Paste column after": "Gludo colofn ar \xf4l",
    "Paste column before": "Gludo colofn cyn",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "Mae gludo nawr yn gweithio yn y modd testun plaen. Caiff testun plaen ei ludo nawr tan gaiff yr opsiwn ei doglo i'w ddiffodd.",
    "Paste or type a link": "Gludo neu deipio dolen",
    "Paste row after": "Gludo rhes ar \xf4l",
    "Paste row before": "Gludo rhes cyn",
    "Paste your embed code below:": "Gludwch eich cod mewnblannu isod:",
    "People": "Pobl",
    "Plugins": "Ategion",
    "Plugins installed ({0}):": "Ategio wedi eu gosod ({0}):",
    "Powered by {0}": "Gyrrir gan {0}",
    "Pre": "Pre",
    "Preferences": "Dewisiadau",
    "Preformatted": "Wedi ei rag-fformatio",
    "Premium plugins:": "Ategion premiwm:",
    "Press the Up and Down arrow keys to resize the editor.": "Gwasgwch y bysellau saeth Fyny a Lawr i newid maint y golygydd.",
    "Press the arrow keys to resize the editor.": "Gwasgwch y bysellau saeth i newid maint y golygydd.",
    "Press {0} for help": "Pwyswch {0} am help",
    "Preview": "Rhagolwg",
    "Previous": "Blaenorol",
    "Print": "Argraffu",
    "Print...": "Argraffu...",
    "Purple": "Porffor",
    "Quotations": "Dyfyniadau",
    "R": "C",
    "Range 0 to 255": "Ystod 0 i 255",
    "Red": "Coch",
    "Red component": "Cydran goch",
    "Redo": "Ailwneud",
    "Remove": "Gwaredu",
    "Remove color": "Tynnu lliw",
    "Remove link": "Tynnu dolen",
    "Replace": "Amnewid",
    "Replace all": "Amnewid y cwbl",
    "Replace with": "Amnewid gyda",
    "Resize": "Ailfeintio",
    "Restore last draft": "Adfer y drafft olaf",
    "Reveal or hide additional toolbar items": "Datgelu neu guddio eitemau bar offer ychwanegol",
    "Rich Text Area": "Ardal testun cyfoethog",
    "Rich Text Area. Press ALT-0 for help.": "Ardal testun cyfoethog. Pwyswch ALT-0 am help.",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "Ardal Testun Cyfoethog. Pwyswch ALT-F9 ar gyfer y ddewislen, Pwyswch ALT-F10 ar gyfer y bar offer. Pwyswch ALT-0 am gymorth",
    "Ridge": "Esgair",
    "Right": "De",
    "Right to left": "De i'r chwith",
    "Row": "Rhes",
    "Row clipboard actions": "Camau clipfwrdd rhes",
    "Row group": "Gr\u0175p rhes",
    "Row header": "Pennyn rhes",
    "Row properties": "Priodweddau rhes",
    "Row type": "Math y rhes",
    "Rows": "Rhesi",
    "Save": "Cadw",
    "Save (if save plugin activated)": "Cadw (os yw'r ategyn cadw yn weithredol)",
    "Scope": "Cwmpas",
    "Search": "Chwilio",
    "Select all": "Dewis popeth",
    "Select...": "Dewis...",
    "Selection": "Dewis",
    "Shortcut": "Llwybr Byr",
    "Show blocks": "Dangos blociau",
    "Show caption": "Dangos capsiwn",
    "Show invisible characters": "Dangos nodau anweledig",
    "Size": "Maint",
    "Solid": "Solid",
    "Source": "Ffynhonnell",
    "Source code": "Cod gwreiddiol",
    "Special Character": "Nod arbennig",
    "Special character...": "Nod arbennig...",
    "Split cell": "Hollti cell",
    "Square": "Sgw\xe2r",
    "Start list at number": "Dechrau rhestr efo rhif",
    "Strikethrough": "Llinell drwodd",
    "Style": "Arddull",
    "Subscript": "Is-sgript",
    "Superscript": "Uwchsgript",
    "Switch to or from fullscreen mode": "Newid i neu o'r modd sgr\xeen llawn",
    "Symbols": "Symbolau",
    "System Font": "Ffont system",
    "Table": "Tabl",
    "Table caption": "Capsiwn tabl",
    "Table properties": "Priodweddau tabl",
    "Table styles": "Arddulliau tabl",
    "Template": "Templed",
    "Templates": "Templedi",
    "Text": "Testun",
    "Text color": "Lliw testun",
    "Text color {0}": "Lliw testun {0}",
    "Text to display": "Testun i'w ddangos",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "Mae'n debyg mai cyfeiriad e-bost yw'r URL hwn. Ydych chi am ychwanegu'r rhagddoddiad mailto:?",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "Mae'n debyg mai dolen allanol yw'r URL hwn. Ydych chi am ychwanegu'r rhagddodiad http:// ?",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "Ymddengys mai dolen allannol yw'r URL a roddoch chi. Ydych chi eisiau ychwanegu'r rhagddodiad https:// gofynnol?",
    "Title": "Teitl",
    "To open the popup, press Shift+Enter": "I agor y llamlen, pwyswch Shift+Enter",
    "Toggle accordion": "Toglo acordion",
    "Tools": "Offer",
    "Top": "Brig",
    "Travel and Places": "Teithio a lleoedd",
    "Turquoise": "Gwyrddlas",
    "Underline": "Tanlinellu",
    "Undo": "Dadwneud",
    "Upload": "Uwchlwytho",
    "Uploading image": "Uwchlwytho delwedd",
    "Upper Alpha": "Priflythrennau",
    "Upper Roman": "Rhufeinig (Priflythrennau)",
    "Url": "URL",
    "User Defined": "Diffinir gan y defnyddiwr",
    "Valid": "Dilys",
    "Version": "Fersiwn",
    "Vertical align": "Alinio fertigol",
    "Vertical space": "Gofod fertigol",
    "View": "Gweld",
    "Visual aids": "Cymorth gweledol",
    "Warn": "Rhybuddio",
    "White": "Gwyn",
    "Width": "Lled",
    "Word count": "Cyfri geiriau",
    "Words": "Geiriau",
    "Words: {0}": "Geiriau: {0}",
    "Yellow": "Melyn",
    "Yes": "Iawn",
    "You are using {0}": "Rydych yn defnyddio {0}",
    "You have unsaved changes are you sure you want to navigate away?": "Mae newidiadau heb eu cadw - ydych chi wir am symud i ffwrdd?",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "Dyw eich porwr ddim yn cynnal mynediad uniongyrchol i'r clipfwrdd. Yn hytrach defnyddiwch y bysellau llwybrau byr Ctrl+X/C/V.",
    "alignment": "aliniad",
    "austral sign": "arwydd austral",
    "cedi sign": "arwydd cedi",
    "colon sign": "Arwydd colon",
    "cruzeiro sign": "Arwydd cruzeiro",
    "currency sign": "Arwydd arian cyfred",
    "dollar sign": "Arwydd dolar",
    "dong sign": "arwydd dong",
    "drachma sign": "arwydd drachma",
    "euro-currency sign": "Arwydd euro",
    "example": "enghraifft",
    "formatting": "fformatio",
    "french franc sign": "Arwydd ffranc Ffrengig",
    "german penny symbol": "arwydd ceiniog almaenig",
    "guarani sign": "arwydd quarani",
    "history": "hanes",
    "hryvnia sign": "arwydd hryvnia",
    "indentation": "mewnoli",
    "indian rupee sign": "arwydd rupee india",
    "kip sign": "arwydd kip",
    "lira sign": "Arwydd lira",
    "livre tournois sign": "arwydd punt tournois",
    "manat sign": "arwydd manat",
    "mill sign": "arwydd mill",
    "naira sign": "arwydd naira",
    "new sheqel sign": "arwydd sheqel newydd",
    "nordic mark sign": "arwydd marc nordig",
    "peseta sign": "arwydd peseta",
    "peso sign": "arwydd peso",
    "ruble sign": "arwydd ruble",
    "rupee sign": "arwydd rupee",
    "spesmilo sign": "arwydd spesmilo",
    "styles": "steiliau",
    "tenge sign": "arwydd tenge",
    "tugrik sign": "arwydd tugrik",
    "turkish lira sign": "arwydd lira twrcaidd",
    "won sign": "arwydd won",
    "yen character": "nod yen",
    "yen/yuan character variant one": "nod yen/yuan amrywiad un",
    "yuan character": "nod yuan",
    "yuan character, in hong kong and taiwan": "nod yuan yn Hong Kong a Taiwan",
    "{0} characters": "{0} nod",
    "{0} columns, {1} rows": "{0} colofn, {1} rhes",
    "{0} words": "{0} o eiriau"
});